export function isCanadaPostal(postal: string) {
  const regex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  return regex.test(postal);
}
